<mat-card class="shadow mb-2 coupon-code-section" [ngClass]="disabled ? 'disabled': ''">
  <mat-card-header class="px-0">
    <mat-card-title>Coupon Code</mat-card-title>
  </mat-card-header>
  <hr class="p-0 mb-4 mt-0">
  <div class="px-2 field">
    @if(form) {
      <form [formGroup]="form">
        <mat-form-field 
        class="form-control" 
        appearance="outline"
        style="width: 100%">
          <input
            matInput
            placeholder="Enter a Coupon Code"
            formControlName="coupon"
            [readonly]="disabled"
          />
      </mat-form-field>
      </form>
    }
  </div>
  <div class="col-md-12 text-center mb-4 mt-1 px-2">
    <button
      mat-raised-button
      class="text-center btn-coupon"
      [disabled]="form?.invalid || disabled"
      (click)="applyCoupon()"
    >
      APPLY COUPON
    </button>
  </div>
</mat-card>